<template>
    <v-container class="pa-2" fluid grid-list-sm >  
        <v-card class="app-page-card shadow-none">
            <v-card-title>
            Settings
            </v-card-title>
            <v-card-text> 
                <v-row>
                    <v-col cols="4">
                        <GroupSetting />
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card> 
    </v-container>
</template>

<script>
import GroupSetting from '../components/student_settings/settings_group.vue'

export default {
    data() {
        return {
        }
    },
    components: {
        GroupSetting
    },
    mounted() {
    },
    methods : {
    }
}
</script>
